import axios, { AxiosInstance } from 'axios'

const apiBaseUrl = process.env.VUE_APP_BAPI;

const xaccelClient: AxiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export default xaccelClient
